import { CorePermissions, PermissionsByServiceResponse } from '@or-sdk/permissions';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { Permissions as permissionsApi } from '@/api';

export const usePermissionsStore = defineStore('permissions', () => {
  const currentUserPermissions = ref<PermissionsByServiceResponse>();
  const isPermissionsLoading = ref(false);
  let loadingPromise: Promise<void> | null = null;

  const getCurrentPermissions = async () => {
    if (loadingPromise) return loadingPromise;

    loadingPromise = (async () => {
      isPermissionsLoading.value = true;
      try {
        currentUserPermissions.value = await permissionsApi.getCurrentForService('customer-portal-ui');
      } finally {
        isPermissionsLoading.value = false;
        loadingPromise = null;
      }
    })();

    return loadingPromise;
  };

  const hasPermission = (permission?: string) => {
    if (!permission) return true;
    return !!currentUserPermissions.value?.[permission];
  };

  const resetStore = () => {
    currentUserPermissions.value = undefined;
  };

  const noAccess = computed(() => {
    return !currentUserPermissions.value?.[CorePermissions.ACCESS] && !isPermissionsLoading.value;
  });

  const canEditAccounts = computed(() => hasPermission('accounts.edit'));

  return {
    // state
    currentUserPermissions,
    isPermissionsLoading,

    // getters
    noAccess,
    canEditAccounts,

    // actions
    getCurrentPermissions,
    hasPermission,
    resetStore,
  };
});
